/**
 * Forecast mode's labels (#327 MR5d): the rail variables' names and a
 * model's name with its grid. Moved from the webapp's forecast mode by
 * step 4 S4-1 so the mobile forecast mode names them the same way.
 */
import {messages} from '@smartmixin/i18n';
import type {MessageDescriptor} from 'react-intl';
import {formatMeshSize} from '../Forecast/mesh';
import type * as Units from '../Units';
import type {
  ForecastCatalogModel,
  ForecastVariableKey,
} from './forecastCatalog';

/**
 * Each rail variable's name: its rail segment's name and tooltip, and the
 * variable in the canvas name, the announcements and the notices.
 */
export const FORECAST_VARIABLE_NAMES: Record<
  ForecastVariableKey,
  MessageDescriptor
> = {
  temperature: messages.metrics.temperature,
  precipitation: messages.metrics.precipitation,
  wind: messages.metrics.wind,
  cloudCover: messages.metrics.cloudCover,
};

/**
 * A forecast model's grid spacing in the user's distance unit ("1.1 km",
 * "0.7 mi"), the label the model screens use (`formatMeshSize`); null when
 * the catalog does not give it.
 */
export const forecastModelGrid = (
  model: Pick<ForecastCatalogModel, 'gridKm'>,
  units: Units.Units,
): string | null => formatMeshSize(model.gridKm, units);

/**
 * "AROME · 1.1 km": the model's name and grid, as the chip and the Auto row
 * show it (the name alone when the grid is unknown). Model names are proper
 * nouns and the middle dot is the app's separator, so nothing here is
 * translated.
 */
export const forecastModelLabel = (
  model: Pick<ForecastCatalogModel, 'title' | 'gridKm'>,
  units: Units.Units,
): string => {
  const grid = forecastModelGrid(model, units);
  return grid === null ? model.title : `${model.title} · ${grid}`;
};
